<div class="login-page">
  <div class="login-brand">
    <div class="logo-icon"><mat-icon>business</mat-icon></div>
    <div>
      <strong>Trusted Technologies</strong>
      <p>HR &amp; Enterprise Platform</p>
    </div>
  </div>

  <mat-card class="login-card">
    <h1>Forgot password</h1>
    <p class="subtitle">We will email a reset link if the account exists.</p>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" />
      </mat-form-field>

      @if (error()) { <div class="error-banner">{{ error() }}</div> }
      @if (message()) { <div class="success-banner">{{ message() }}</div> }

      <button mat-raised-button color="primary" class="full-width submit-btn" type="submit" [disabled]="loading() || form.invalid">
        @if (loading()) { <mat-spinner diameter="22"></mat-spinner> } @else { Send reset link }
      </button>
    </form>

    <div class="auth-links">
      <a routerLink="/login">Back to sign in</a>
    </div>
  </mat-card>
</div>
